import { forwardRef, type Ref, type SVGProps } from 'react';
import { SvgIcon } from '../../components/icon/icon';

interface SVGRProps {
  title?: string;
  titleId?: string;
}
const TicketSolid = (
  { title, titleId, ...props }: SVGProps<SVGSVGElement> & SVGRProps,
  ref: Ref<SVGSVGElement>,
) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="none"
    viewBox="0 0 24 24"
    ref={ref}
    aria-labelledby={titleId}
    {...props}>
    {title ? <title id={titleId}>{title}</title> : null}
    <path
      fill="currentColor"
      d="m12.651 12.347-1.046-1.046a.5.5 0 0 1 .707-.708l1.046 1.047a.5.5 0 0 1-.707.707m-3.14-3.14-.693-.693-5.64 5.641c-.284.284-.454.633-.493.955-.038.319.055.565.207.717l.717.717c.531-.415 1.153-.69 1.789-.766.797-.096 1.567.125 2.109.667.541.541.763 1.312.667 2.109-.076.636-.352 1.257-.767 1.788l.718.718c.152.152.398.245.717.207.322-.039.671-.209.955-.492l5.64-5.641-.693-.694a.5.5 0 0 1 .707-.707l.694.694 4.309-4.31c.283-.283.453-.632.492-.954.038-.319-.055-.565-.207-.717l-.718-.718c-.531.415-1.153.691-1.789.768-.796.095-1.567-.127-2.108-.668-.541-.542-.763-1.312-.668-2.108.077-.636.352-1.259.767-1.79l-.717-.717c-.152-.152-.398-.245-.717-.207-.322.039-.671.209-.955.492l-4.309 4.31.694.692a.5.5 0 0 1-.708.707"
      vectorEffect="non-scaling-stroke"
    />
  </svg>
);
const ForwardRef = forwardRef(TicketSolid) as SvgIcon;
export { ForwardRef as ReactComponent };
